<script>
import _ from 'lodash'
import moment from 'moment'
import PotentialService from '@/request/patient/potential'
import PositionService from '@/request/dictionary/position'
export default {
  name: 'PatientPotentialEdit',
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      saving: false,
      positionSelection: [], // 地址列表
      selectedPosition: [], // 选中的地址
      editPotential: {}
    }
  },
  computed: {},
  created: function () {
    this.init()
  },
  mounted: function () {},
  beforeDestroy () {},
  watch: {
    value () {
      this.init()
    },
    selectedPosition (val) {
      if (_.isEmpty(val)) {
        if (_.isEmpty(this.positionSelection)) {
          this.listPosition()
        }
        return
      }
      this.listPosition(null, null, val, 0)
    },
    'editPotential.identity': function (val) {
      if (!val) {
        return
      }
      if (val.length !== 18) {
        this.$message.error('身份证号有误')
        return
      }
      let bd = val.substring(6, 14)
      let date = moment(bd, 'YYYYMMDD').startOf('day').valueOf()
      this.$set(this.editPotential, 'birthday', date)
    }
  },
  methods: {
    init () {
      if (_.isEmpty(this.value)) {
        this.editPotential = {}
        return
      }
      this.editPotential = _.cloneDeep(this.value)
      let ps = []
      if (this.editPotential.provinceSn) {
        ps.push(this.editPotential.provinceSn)
      }
      if (this.editPotential.citySn && ps.length === 1) {
        ps.push(this.editPotential.citySn)
      }
      if (this.editPotential.countySn && ps.length === 2) {
        ps.push(this.editPotential.countySn)
      }
      if (this.editPotential.townsSn && ps.length === 3) {
        ps.push(this.editPotential.townsSn)
      }
      if (this.editPotential.villageSn && ps.length === 4) {
        ps.push(this.editPotential.villageSn)
      }
      this.selectedPosition = _.clone(ps)
    },
    handleCancelEditPotential () {
      this.editPotential = {}
      this.$emit('close')
    },
    listPosition: function (parent, best, sns, index) {
      if (!best) {
        best = 5
      }
      if (!index) {
        index = 0
      }
      if (parent && parent.leaf) {
        return
      }
      let self = this
      let sn = (!_.isEmpty(sns) && sns.length > index) ? sns[index] : null
      if (sn && parent && !_.isEmpty(parent.children)) {
        let chi = _.findIndex(parent.children, {'sn': sn})
        if (chi >= 0) {
          self.listPosition(parent.children[chi], best, sns, ++index)
        }
        return
      }
      if (!parent && !_.isEmpty(sns) && self.positionSelection.length > 0) {
        index = 0
        let chi = _.findIndex(self.positionSelection, {'sn': sns[index]})
        if (chi >= 0) {
          self.listPosition(self.positionSelection[chi], best, sns, ++index)
        }
        return
      }
      let level = parent ? (parent.level + 1) : 1
      PositionService.list({
        psn: parent ? parent.sn : null
      }).then(data => {
        data = data.result
        if (!_.isEmpty(data)) {
          let children = []
          for (let i = 0; i < data.length; i++) {
            let item = _.cloneDeep(data[i])
            item.index = i
            if (level >= best) {
              item.leaf = true
            } else {
              item.leaf = false
              item.children = []
            }
            children.push(item)
          }
          if (parent) {
            children = parent.children = _.clone(children)
          } else {
            children = self.positionSelection = _.clone(children)
          }
          if (sn) {
            let chi = _.findIndex(children, {'sn': sns[index]})
            if (chi >= 0) {
              self.listPosition(children[chi], best, sns, ++index)
            }
          }
        } else {
          if (parent) {
            parent.leaf = true
            delete parent.children
          }
        }
      }, () => {
        if (parent) {
          parent.leaf = true
          delete parent.children
        }
      })
    },
    changePatientPostion () {
      let self = this
      return new Promise((resolve) => {
        if (_.isEmpty(self.selectedPosition)) {
          self.editPotential.provinceSn = null
          self.editPotential.province = null
          self.editPotential.citySn = null
          self.editPotential.city = null
          self.editPotential.countySn = null
          self.editPotential.county = null
          self.editPotential.townsSn = null
          self.editPotential.towns = null
          self.editPotential.villageSn = null
          self.editPotential.village = null
          resolve()
          return
        }
        PositionService.path({
          sn: _.last(self.selectedPosition)
        }).then(res => {
          let data = res.result
          if (!_.isEmpty(data)) {
            self.editPotential.provinceSn = data[0] ? data[0].sn : null
            self.editPotential.province = data[0] ? data[0].name : null
            self.editPotential.citySn = data[1] ? data[1].sn : null
            self.editPotential.city = data[1] ? data[1].name : null
            self.editPotential.countySn = data[2] ? data[2].sn : null
            self.editPotential.county = data[2] ? data[2].name : null
            self.editPotential.townsSn = data[3] ? data[3].sn : null
            self.editPotential.towns = data[3] ? data[3].name : null
            self.editPotential.villageSn = data[4] ? data[4].sn : null
            self.editPotential.village = data[4] ? data[4].name : null
          } else {
            self.editPotential.provinceSn = null
            self.editPotential.province = null
            self.editPotential.citySn = null
            self.editPotential.city = null
            self.editPotential.countySn = null
            self.editPotential.county = null
            self.editPotential.townsSn = null
            self.editPotential.towns = null
            self.editPotential.villageSn = null
            self.editPotential.village = null
          }
        }).finally(() => {
          resolve()
        })
      })
    },
    save () {
      let self = this
      let message = this.$message({
        message: '正在保存患者信息...',
        center: true,
        duration: 0
      })
      self.saving = true
      self.changePatientPostion().finally(() => {
        let _pat = _.cloneDeep(self.editPotential)
        if (_.isEqual(_pat, self.value)) {
          self.$message({
            message: '保存患者信息成功',
            type: 'success'
          })
          message.close()
          self.saving = false
          this.$emit('saveDone', self.value)
          return
        }
        self.$refs['editForm'].validate(valid => {
          if (valid) {
            PotentialService.save(_pat).then(res => {
              let data = res.result || null
              if (!data) {
                self.$message.error('保存患者信息失败')
                return
              }
              self.$message({
                message: '保存患者信息成功',
                type: 'success'
              })
              this.$emit('input', data)
              this.$emit('saveDone', data)
            }, err => {
              self.$message.error(err)
              this.$emit('error', err)
            }).finally(() => {
              message.close()
              self.saving = false
            })
          } else {
            self.$message.error('表单验证失败!')
            self.saving = false
          }
        })
      })
    },
    openCascader (val) {
      if (val) {
        this.$nextTick(() => {
          const lis = this.$refs.cascader.panel.$el.lastChild.querySelectorAll('li')
          _.forEach(lis, val => {
            if (val.className.indexOf('is-active') !== -1) {
              val.click()
            }
          })
        })
      }
    }
  }
}
</script>

<template>
  <el-form ref="editForm" label-position="right" label-width="100px" :model="editPotential" :disabled="saving">
    <el-form-item label="姓名" prop="name" :rules="[{ required: true, message: '姓名不能为空' }]">
      <el-input v-model="editPotential.name" placeholder="请输入患者姓名"></el-input>
    </el-form-item>
    <el-form-item label="电话" prop="mobile" :rules="[{ required: true, message: '电话不能为空' }]">
      <el-input v-model="editPotential.mobile" placeholder="请输入患者电话"></el-input>
    </el-form-item>
    <el-form-item label="身份证" prop="identity">
      <el-input v-model="editPotential.identity" placeholder="请输入患者身份证号码"></el-input>
    </el-form-item>
    <el-form-item label="出生日期" prop="birthday">
      <el-date-picker
        :disabled="!!editPotential.identity"
        v-model="editPotential.birthday"
        type="date"
        format="yyyy年MM月dd日"
        value-format="timestamp"
        placeholder="选择日期"
        style="width: 100%;">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="性别" prop="sex">
      <el-radio-group v-model="editPotential.sex">
        <el-radio :label="parseInt(1)" border>男</el-radio>
        <el-radio :label="parseInt(2)" border>女</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="住址">
      <el-cascader
        ref="cascader"
        @visible-change="openCascader"
        :options="positionSelection"
        :props="{checkStrictly: true, value: 'sn', label: 'name', children: 'children'}"
        clearable
        v-model="selectedPosition"
        style="width: 100%;">
      </el-cascader>
    </el-form-item>
    <el-form-item label="详细地址" prop="house">
      <el-input v-model="editPotential.house" placeholder="请输入患者详细地址：xx幢xx单元xx室"></el-input>
    </el-form-item>
    <el-form-item v-if="showButtons">
      <el-button @click="handleCancelEditPotential">取消</el-button>
      <el-button type="primary" @click="save()">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
